export function SectionHeader({ eyebrow, title, subtitle, align = "left" }) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""} mb-12`}>
      {eyebrow && <div className="font-accent text-xs text-gold mb-4">{eyebrow}</div>}
      <h2 className="font-display text-4xl sm:text-5xl text-white leading-tight">{title}</h2>
      {subtitle && <p className="mt-5 text-zinc-400 text-base leading-relaxed">{subtitle}</p>}
    </div>
  );
}

export function PageHeader({ eyebrow, title, subtitle, bg }) {
  return (
    <section className="relative border-b hairline overflow-hidden">
      {bg && (
        <div className="absolute inset-0">
          <img src={bg} alt="" className="w-full h-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-[#0a0a0a]" />
        </div>
      )}
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-24 lg:py-32">
        {eyebrow && <div className="font-accent text-xs text-gold mb-5">{eyebrow}</div>}
        <h1 className="font-display text-5xl lg:text-6xl text-white tracking-tight max-w-3xl">{title}</h1>
        {subtitle && <p className="mt-6 text-lg text-zinc-300 max-w-2xl leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}

export function EmptyState({ title = "Nothing here yet", hint }) {
  return (
    <div className="border hairline rounded-xl px-8 py-16 text-center bg-black/30">
      <p className="text-zinc-300 font-display text-xl">{title}</p>
      {hint && <p className="text-sm text-zinc-500 mt-2">{hint}</p>}
    </div>
  );
}
